// extracted by mini-css-extract-plugin
export var boxSection = "style-module--box-section--88da4";
export var boxSection__box = "style-module--box-section__box--01322";
export var boxSection__boxes = "style-module--box-section__boxes--22fa4";